import React, { useState } from 'react';

import { useTheme } from "../../../utils/Theme";

import { SVGProps } from './SVG.props';

const GithubIcon = (props: SVGProps): JSX.Element => {
  const theme = useTheme();
  const { width, height, fill } = props;

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const fillColor = isHovered ? "#FF4D03" : "#FA8029";

  // Paste converted svg below
  // https://react-svgr.com/playground/?typescript=true
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 16 16"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <g clipPath="url(#clip0_3621_28106)">
        <path
          fill={fillColor}
          d="M15.12.325C14.533-.225 13.827-.5 13-.5H3C2.174-.5.087-.225-.5.325c-.587.55-.88 1.213-.88 1.987v10.876c0 .774.293 1.437.88 1.987S2.174 16 3 16h2.334c.152 0 .267-.005.343-.015a.41.41 0 00.23-.127c.076-.075.114-.184.114-.327l-.006-.664a140.42 140.42 0 01-.004-1.006l-.24.039a3.244 3.244 0 01-.578.035 4.744 4.744 0 01-.724-.069 1.679 1.679 0 01-.698-.293 1.246 1.246 0 01-.458-.6l-.105-.225a2.42 2.42 0 00-.328-.498 1.235 1.235 0 00-.453-.371l-.072-.049a.75.75 0 01-.136-.117.54.54 0 01-.094-.137c-.021-.045-.003-.083.052-.112.056-.03.156-.045.303-.045l.208.03c.138.026.31.104.515.234.206.132.38.306.505.508.16.267.352.47.578.61.226.14.454.21.683.21.229 0 .426-.016.594-.048.162-.031.319-.08.468-.147.063-.436.233-.772.51-1.006a7.56 7.56 0 01-1.067-.176 4.415 4.415 0 01-.98-.38 2.77 2.77 0 01-.838-.655c-.222-.26-.404-.602-.547-1.025-.142-.423-.213-.912-.213-1.466 0-.787.274-1.458.823-2.012-.257-.591-.233-1.256.072-1.99.202-.06.5-.016.897.13.395.147.685.272.87.376.183.105.33.193.442.264a7.857 7.857 0 012-.253c.688 0 1.354.084 2 .253l.396-.234c.304-.171.625-.315.959-.43.368-.13.648-.165.844-.107.312.736.34 1.4.082 1.992.549.553.823 1.224.823 2.012 0 .554-.07 1.044-.213 1.47-.142.426-.326.768-.552 1.025a2.89 2.89 0 01-.844.65 4.407 4.407 0 01-.979.38c-.35.084-.707.143-1.067.177.36.292.54.754.54 1.386v2.335c0 .11.018.2.053.268a.293.293 0 00.167.142.967.967 0 00.203.048c.06.007.144.01.255.01H13c.827 0 1.533-.275 2.12-.826.586-.55.88-1.212.88-1.987V2.312c0-.774-.293-1.437-.88-1.987z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3621_28106">
          <rect width="16" height="16" fill="#fff" rx="3"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export default GithubIcon;
